import React from 'react';
import ManageControls from 'src/components/manage-controls.jsx';
import { SearchButtons } from 'src/components/control-buttons.jsx';
import useManageCrud from 'src/@manage/use-manage.js';
import { makePaginatedTableColumns } from 'lib/helpers/table.jsx';
import Input from 'lib/components/input.jsx';
import SearchPanel from 'src/components/search-panel.jsx';
import SearchResults from 'src/components/search-results.jsx';
import Badge from 'lib/components/badge.jsx';
import { intlHeaderTexts } from '#lib/helpers/intlHeaders.js';
import { LoadingSkeleton, LoadingIndicator } from '#lib/components/loading.jsx';
import { cn } from '#lib/helpers/class.js';
export default function ThemeSearch() {
    const { data, stateFlags, searchParams, getSearchFieldProps, setMultipleSearchFields, paginationProps } =
        useManageCrud('theme');

    const columnProps = makePaginatedTableColumns(
        data,
        {
            searchParams
        },
        {
            omit: ['id'],
            sortable: false,
            isLoading: stateFlags.isLoading || stateFlags.isRefetching,
            headerText: (accessor) => intlHeaderTexts(_t.crud.theme)(accessor)
        }
    );

    console.log('props: ', columnProps)

    columnProps.columns = columnProps.columns.map((c) => {
        if (c.accessor === 'enabled') {
            c.Cell = function renderCell({ row }) {
                return (
                    <div>
                        {row.enabled ? (
                            <Badge color="green">{_t.crud.theme.enabled()}</Badge>
                        ) : (
                            <Badge color="neutral">{_t.crud.theme.disabled()}</Badge>
                        )}
                    </div>
                );
            };
        }
        return c;
    });

    return (
        <main>
            <div className="fixed w-full h-[116px] bg-white top-0 left-0 z-50 shadow-sm">
                <ManageControls.BarSlot>
                    <p className="text-2xl"> {_t.crud.theme.themes()}</p>
                </ManageControls.BarSlot>
                <ManageControls.ButtonSlot>
                    <SearchButtons add={true} />
                </ManageControls.ButtonSlot>
            </div>
            <SearchPanel searchParams={searchParams} onSubmit={setMultipleSearchFields} busy={stateFlags.isRefetching}>
                <Input.Full
                    {...getSearchFieldProps('query')}
                    className="flex-grow"
                    type="search"
                    label={_t.global.freeTextSearch()}
                />
            </SearchPanel>
            {(stateFlags.isLoading || stateFlags.isRefetching) && (
                <LoadingSkeleton className="h-screen flex items-center justify-center fixed inset-4 ">
                    <LoadingIndicator></LoadingIndicator>
                </LoadingSkeleton>
            )}
            {!stateFlags.isLoading && (
                <div className={cn(stateFlags.isRefetching && 'opacity-50')}>
                    <SearchResults
                        data={data}
                        isSuccess={stateFlags.isSuccess}
                        {...columnProps}
                        {...paginationProps}
                        paginated
                    />
                </div>
            )}
        </main>
    );
}
